import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ allowedRoles, children }) => {
  const user = useSelector((state) => state.user);

  const token = localStorage.getItem("authToken") || sessionStorage.getItem("authToken");

  const isAuthenticated = user?.isAuthenticated && !!token;
  const userRole = user?.role;

  // If not logged in
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // If roles are specified, check role access
  if (allowedRoles && allowedRoles.length > 0) {
    if (!userRole || !allowedRoles.includes(userRole)) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  // Access granted
  return children;
};

export default PrivateRoute;
